var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('a',{attrs:{"href":_vm.value,"target":"_blank"}},[(_vm.isImage)?_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.value,"alt":_vm.field.label}}):_c('span',[_vm._v("\n            "+_vm._s(_vm.field.label ?? _vm.value)+"\n            "),_c('i',{staticClass:"fas fa-external-link-alt"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }